import React, {useEffect} from 'react';
import {Grid} from '@mui/material';
import BookingSearchInput from './BookingSearchInput';
import {useDispatch, useSelector} from 'react-redux';
import {fetchBookingDetails} from '../../action/bookingsCommands';
import {makeBookingSelector} from '../../selector/bookingsSelector';
import {useNavigate, useParams} from 'react-router';
import {makeBookingSearchDetailsUrl} from '../../routes';
import BookingInfo from './BookingInfo';
import BookingRawInfo from './BookingRawInfo';
import BookingLocations from './BookingDepots';
import {makeHasPermissionSelector} from '../../selector/authenticationSelector';
import Permission from '../../common/permissions';


const SearchBookingPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const params = useParams<{ bookingId?: string }>();
    const booking = useSelector(makeBookingSelector(params.bookingId || ''));
    const hasTechnicalInfoPermission = useSelector(makeHasPermissionSelector(Permission.showTechnicalInfo()));
    useEffect(() => {
        if (params.bookingId) {
            dispatch(fetchBookingDetails({ bookingId: params.bookingId }));
        }
    }, [params.bookingId]);
    const handleSearchBooking = (bookingId: string) => {
        navigate(makeBookingSearchDetailsUrl(bookingId));
    };
    const handleRefreshBooking = () => {
        if (!params.bookingId) {
            return;
        }
        dispatch(fetchBookingDetails({ bookingId: params.bookingId }));
    };
    return (
        <Grid container={true} spacing={2}>
            <Grid item={true} xs={12} md={9}>
                <BookingSearchInput
                    currentBookingId={params.bookingId}
                    onSearch={handleSearchBooking}
                    onRefresh={handleRefreshBooking}
                />
            </Grid>
            <Grid item={true} xs={12} md={9}>
                {booking && <BookingInfo booking={booking} />}
            </Grid>
            {booking && <BookingLocations booking={booking} />}
            {hasTechnicalInfoPermission && (
                <Grid item={true} xs={12} md={9}>
                    {booking && <BookingRawInfo booking={booking} />}
                </Grid>
            )}
        </Grid>
    );
};

export default SearchBookingPage;
